import { get, handleError } from '@/lib/http-adapter';
import { keepPublicClassPacks } from '@/helpers/class-pack';
import { ClassPack, ClassPackGroup } from '@/state/class-pack-groups';

export const getClassPackGroups = async (params: {
  include_class_packs: boolean;
  class_id?: string;
}) => {
  try {
    const response = await get<{
      class_pack_groups: ClassPackGroup[];
    }>('/public/class-pack-groups', {
      params,
    });

    return keepPublicClassPacks(response?.class_pack_groups);
  } catch (error) {
    handleError(error);
  }
};

// Deliberately unfiltered, unlike the listing above: a pack sold off a direct
// link is PRIVATE by design, and its buyers still need this page.
export const getClassPackDetails = async ({ slug }: { slug: string }) => {
  try {
    const response = await get<{ class_pack: ClassPack }>(
      `/public/class-packs/${slug}`
    );
    return response?.class_pack ?? null;
  } catch (error) {
    handleError(error);
  }
};
